import { api } from "@/services/api";
import { UserModel } from "@/types/common";
import { PostModel, PostViewResponse } from "@/types/post";

const postApi = api.injectEndpoints({
  endpoints: (build) => ({
    postView: build.query<PostViewResponse, void>({
      query: (payload) => {
        return {
          url: "api/Post/PostView",
          method: "get",
        };
      },
    }),
    getPosts: build.mutation<PostModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/GetPosts",
          method: "post",
          data: payload,
        };
      },
    }),
    getPostUsers: build.mutation<UserModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/GetPostUsers",
          method: "post",
          data: payload,
        };
      },
    }),
    addEditPost: build.mutation<PostModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/AddUpdatePost",
          method: "post",
          data: payload,
        };
      },
    }),
    deletePost: build.mutation<number, any>({
      query: (payload) => {
        return {
          url: "api/Post/DeletePost",
          method: "post",
          data: payload,
        };
      },
    }),
    likeDislikePost: build.mutation<PostModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/LikeDislikePost",
          method: "post",
          data: payload,
        };
      },
    }),
    reportContent: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Post/ReportContent",
          method: "post",
          data: payload,
        };
      },
    }),
    generatePostDescription: build.mutation<any, string>({
      query: (payload) => {
        return {
          url: "api/Post/GeneratePostDescription",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostViewQuery,
  useGetPostsMutation,
  useGetPostUsersMutation,
  useAddEditPostMutation,
  useDeletePostMutation,
  useLikeDislikePostMutation,
  useReportContentMutation,
  useGeneratePostDescriptionMutation,
} = postApi;

export default postApi;
